//force run 2026-03-10 2
import React from "react";
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

import 'bootstrap/dist/js/bootstrap.js';
import './bootstrap';

import "@vibe/core/tokens";

import { AuthProvider } from "./react/auth/useAuth.jsx";

import Main from "./react/main.jsx";

const rootElement = document.getElementById("react");
const root = ReactDOM.createRoot(rootElement);

root.render(
    <BrowserRouter>
        <AuthProvider>
            <Main />
        </AuthProvider>
    </BrowserRouter>
);